/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import styled, { css } from 'styled-components';
import { media } from '@exo/frontend-common-style-utils';
import { Row } from './Row.styles';
import { Column } from './Column.styles';

export const Grid = styled('div')<{ hasRowGap?: boolean; hasColumnGap?: boolean; isFluid?: boolean }>`
  ${props => ! props.isFluid && css`
    max-width: 99rem;
    margin-right: auto;
    margin-left: auto;
    padding-left: ${props.theme.spacing.inline.sM};
    padding-right: ${props.theme.spacing.inline.sM};

    ${media.greaterThan(props, 'medium').then(css`
      padding-left: ${props.theme.spacing.inline.sXL};
      padding-right: ${props.theme.spacing.inline.sXL};
    `)}

    ${media.greaterThan(props, 'max').then(css`
      padding-left: ${props.theme.spacing.inline.sXXL};
      padding-right: ${props.theme.spacing.inline.sXXL};
    `)}
  `}

  ${Column} {
    ${props => props.hasColumnGap && `
      padding-right: ${props.theme.spacing.inline.sM};
      padding-left: ${props.theme.spacing.inline.sM};
    `}
  }

  ${Row} {
    ${props => props.hasColumnGap && `
      margin-left: -${props.theme.spacing.inline.sM};
      margin-right: -${props.theme.spacing.inline.sM};
    `}

    ${props => props.hasRowGap && `
      row-gap: calc(2 * ${props.theme.spacing.inline.sM});
    `}
  }

  ${props => props.hasRowGap && `
    display: flex;
    flex-direction: column;
    row-gap: calc(2 * ${props.theme.spacing.inline.sM});
  `}

  & & {
    margin-left: -${props => props.theme.spacing.inline.sM};
    margin-right: -${props => props.theme.spacing.inline.sM};
    max-width: none;

    ${props => media.greaterThan(props, 'medium').then(css`
      margin-left: -${props.theme.spacing.inline.sXL};
      margin-right: -${props.theme.spacing.inline.sXL};
    `)}

    ${props => media.greaterThan(props, 'max').then(css`
      margin-left: -${props.theme.spacing.inline.sXXL};
      margin-right: -${props.theme.spacing.inline.sXXL};
    `)}
  }
`;
